import { AxiosResponse } from 'axios';
import { IErrorMessageHandler } from '@/shared/interfaces/error-message-handler';

/**
 * I forgot this even existed.
 * I didn't know this existed.
 * Customize API error message toasts based on endpoint, method, and response status match.
 * This allows us to provide more detailed error messages for our end users.
 */
export const errorMessageHandlers: IErrorMessageHandler[] = [
  {
    routeMatches: ['/property-api/units'],
    methods: ['POST', 'PUT'],
    statuses: [400],
    message: (response) => {
      if (response.data?.proxyError?.includes('ERR_SF_MAX_NUM_UNITS_ENABLED')) {
        return (
          response.config.method === 'POST'
            ? `Unit(s) cannot be inserted with status "enabled" due to maximum enabled unit limit!`
            : `Unit(s) cannot be set with status "enabled" due to maximum enabled unit limit!`
        );
      }

      return `Error adding unit!`;
    },
  },
  {
    routeMatches: ['/current-user/'],
    methods: ['PUT'],
    statuses: [403],
    message: (response: AxiosResponse): string => {
      if (JSON.parse(response.config.data || {}).newPassword) {
        return `Profile & password update failed. Current password is incorrect!`;
      }

      if (JSON.parse(response.config.data || {}).password) {
        return `Profile update failed. Current password is incorrect!`;
      }

      return `Profile update failed. Please try again!`;
    },
  },
  {
    routeMatches: ['/auth/user'],
    methods: ['POST'],
    statuses: [401],
    message: () => 'Password is incorrect.',
    exact: true,
  },
];
